import { useEffect, useState } from 'react'

import { getBroadcastChannel } from './channelRegistry'

/**
 * Creates a BroadcastChannel and attaches a message handler.
 *
 * @param channel The name of the BroadcastChannel
 * @param onMessage A callback function invoked when a message is received
 * @returns A BroadcastChannel instance
 */
export function useBroadcastChannel(
  channel: string,
  onMessage?: (ev: MessageEvent) => void,
) {
  const [broadcastChannel] = useState<BroadcastChannel>(
    getBroadcastChannel(channel),
  )

  useEffect(() => {
    if (onMessage) {
      broadcastChannel.addEventListener('message', onMessage)
      return () => broadcastChannel.removeEventListener('message', onMessage)
    }
  }, [broadcastChannel, onMessage])

  return broadcastChannel
}
